<span class="h3 text-dark-blue show-for-medium">
  <span>{{flightDetails.originCity}}<span *ngIf="flightDetails.originStateOrCountry">,
      {{flightDetails.originStateOrCountry}}</span></span>
  <span class="leadingWhtSpc trailingWhtSpc">{{'reaccom.to' | translate}}</span>
  <span>{{flightDetails.destinationCity}}<span *ngIf="flightDetails.destinationStateOrCountry">,
      {{flightDetails.destinationStateOrCountry}}</span></span>
</span>
<span class="h3 text-dark-blue hide-for-medium">
  <span>{{flightDetails.originAirportCode}}</span>
  <span class="leadingWhtSpc trailingWhtSpc">{{'reaccom.to' | translate}}</span>
  <span>{{flightDetails.destinationAirportCode}}</span>
</span>
<div class="flight-card-date text-medium-gray">
  <span class="h3">{{departureDate}}
    <br class="hide-for-medium"><span *ngIf="flightDetails.nextDayArrivalAlert">
      <span class="leadingWhtSpc trailingWhtSpc">{{'reaccom.to' | translate}}</span><br class="hide-for-medium">{{arrivalDate}}
    </span>
  </span>
</div>
<div class="grid-x grid-margin-x show-for-medium">
  <div class="cell small-9">
    <div class="grid-x grid-margin-x show-for-medium">
      <div class="cell small-6">
        <div class="grid-x grid-margin-x city-pair">
          <div class="cell small-5">{{flightDetails.originAirportCode}}</div>
          <div class="cell small-1"></div>
          <div class="cell small-5">{{flightDetails.destinationAirportCode}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <app-flight-details [flightDetails]="flightDetails" [localeStr]="localeStr" [timeFormat]="timeFormat"></app-flight-details>
    <div class="grid-x grid-margin-x -small aircraft-info">
      <div class="cell small-12">
        <span [class.highlightFields]="flightDetails.highlightedFields.operatingCarrier">{{flightDetails.operatingCarrierCode}}</span>
        <span [class.highlightFields]="flightDetails.highlightedFields.flightNumber"> {{flightDetails.flightNumber}}
        </span>
        <span>
          <span *ngIf="flightDetails.aircraftType">
            <span aria-hidden="true" class="icon-square -wide-margins"> </span>
            <span [class.highlightFields]="flightDetails.highlightedFields.aircraftType">{{flightDetails.aircraftType}}
            </span></span>
        </span>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <span class="cell small-12 text-orange flight-alert" *ngIf="flightDetails.nextDayDepartureAlert">
        <span >{{'reaccom.departs' | translate}}</span>:{{nextDayDeparture}}
      </span>
    </div>
    <div class="grid-x grid-margin-x">
      <span class="cell small-12 text-orange flight-alert" *ngIf="flightDetails.nextDayArrivalAlert">
        <span >{{'reaccom.arrives' | translate}}</span>:{{nextDayArrival}}
      </span>
    </div>
    <div class="grid-x grid-margin-x">
      <span class="cell small-12 text-orange flight-alert" *ngFor="let flightAlert of flightDetails.flightAlerts as results; let i = index">
        {{ flightAlert }}
      </span>
    </div>
  </div>
  <div class="cell small-12 medium-3">
    <div class="xxtext-left" *ngFor="let seat of flightDetails.travelers as results; let i = index">
      <span [class.highlightFields]="flightDetails.highlightedFields.seatChanged" *ngIf="seat.seatNumber">{{seat.seatNumber}}</span>
      <span [class.highlightFields]="flightDetails.highlightedFields.seatChanged" *ngIf="seat.seatPosition">,
        {{seat.seatPosition}}</span>
      <span [class.highlightFields]="flightDetails.highlightedFields.seatChanged" *ngIf="seat.seatDescription">,
        {{seat.seatDescription}}</span>
    </div>
  </div>
</div>
<div *ngIf="!lastSegment || !lastSlice" class="flight-card-separator">
  <div class="flight-card-separator-text stopOverText" *ngIf="flightDetails.stopOverAirportAlert">
    <span>
      {{flightDetails.stopOverAirportAlert}} {{flightDetails.destinationCity}}<span *ngIf="flightDetails.destinationStateOrCountry">,{{flightDetails.destinationStateOrCountry}}</span>
      ({{flightDetails.destinationAirportCode}})
    </span>
  </div>
</div>